module.exports = __webpack_public_path__ + "media/foreplay-loading_anubis.81df2401.webm";